import { Component, OnInit, Input } from '@angular/core';
import { ArrowContainer } from 'src/app/models/cabiancaChart.model';

@Component({
  selector: 'app-slotarrow',
  templateUrl: './slotarrow.component.html',
  styleUrls: ['./slotarrow.component.css']
})
export class SlotarrowComponent implements OnInit {
  @Input() arrow: ArrowContainer
  @Input() type: string
  constructor() { }

  ngOnInit() {
  }

}
